import {Component, OnInit} from '@angular/core';
import {Constant} from '../../../global/util/Constant';
import {VerifierService} from '../../../user/service/verifier.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InformType} from '../../../global/util/enum/InformType';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {Dialog} from '../../../global/util/Dialog';
import {Document} from '../../../user/model/Document';
import {DocumentState} from '../../../global/util/DocumentState';
import {Documentmodification} from '../../../user/model/Documentmodification';
import {CertificateDetailComponent} from '../certificate-detail/certificate-detail.component';
import {Operator} from '../../../user/model/Operator';
import {OperationType} from '../../../global/util/OperationType';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {TranslateService} from '@ngx-translate/core';
import {PublicService} from '../../../user/service/public.service';

@Component({
  selector: 'app-vifierbycode',
  templateUrl: './verifierbycode.component.html',
  styleUrls: ['./verifierbycode.component.css']
})
export class VerifierbycodeComponent implements OnInit {

  public verifybycodeForm: FormGroup;
  public operatorsInfo: any[] = [];
  public urlStream;
  public loading: boolean;
  private entityName: string;
  public wrongVerification = true;
  public resumeHashResource: string;
  public document: Document;
  public documentmodifications: Documentmodification[] = [];
  public urlLastDocumentResource: string;
  public havePermissionToDownload: boolean;

  constructor(private verifierService: VerifierService,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private translate: TranslateService,
              private publicService: PublicService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.verifybycodeForm = this.formBuilder.group(
      {
        resumeHash: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(12)])]
      });
  }

  public verify() {
    if (this.verifybycodeForm.invalid) {
      this.markAsTouchedAllControls();
      return;
    }
    this.loadOperatorsInfo(this.resumeHashResource);
  }

  private loadOperatorsInfo(resumeHash: string) {
    const urlVerifier = Constant.ROOT_API_V1.concat('/public/documents/resources/')
      .concat(resumeHash)
      .concat('/verifier');

    this.urlStream = Constant.ROOT_API_V1.concat('/public/documents/resources/')
      .concat(resumeHash)
      .concat('/stream');

    this.loading = true;
    this.entityName = this.translate.instant('TITLE.VERIFICATION');
    this.verifierService.get(urlVerifier).subscribe((next: any) => {
      this.loading = false;
      this.operatorsInfo = next._embedded.operatorsInfo;
      this.documentmodifications = next._embedded.documentmodifications;
      this.urlLastDocumentResource = next._embedded.urlLastDocumentResource;
      this.wrongVerification = false;
      this.document = next._embedded.document;
      this.verifyHavePermission();
    }, error => {
      // TODO investigate and improvement next treatment for it doesn't get 404
      if (error.status) {
        this.wrongVerification = true;
        if (HttpStatusCode.NOT_FOUND === error.status) {
          Dialog.show(InformType.Info, this.entityName, error.error.message);
        } else if (HttpStatusCode.SERVICE_UNAVAILABLE === error.status) {
          Dialog.show(InformType.Warning, this.entityName, error.error.message);
        } else if (HttpStatusCode.METHOD_NOT_ALLOWED === error.status) {
          Dialog.show(InformType.Danger, this.entityName, error.error.message);
        } else {
          Dialog.show(InformType.Danger, this.entityName);
        }
        this.loading = false;
      }
    });
  }

  public hasntCertificate(operatorsInfo: any): boolean {
    return OperationType.REVIEW === operatorsInfo.operationId ||
      (TypeSignature.ELECTRONIC === operatorsInfo.typeSignature &&
        !this.hasDocumentIntegrity(operatorsInfo)) ||
      TypeSignature.CLOUD === operatorsInfo.typeSignature ||
      Constant.CORRECT_OPERATION !== operatorsInfo.correctOperation;
  }

  public isInvalidControl(ctrlName: string) {
    return this.verifybycodeForm.get(ctrlName).invalid && this.verifybycodeForm.get(ctrlName).touched;
  }

  private markAsTouchedAllControls() {
    Object.values(this.verifybycodeForm.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  public getErrorMessageBy(controlName: string): string {
    const control = this.verifybycodeForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasnotRequiredSizeError = control.hasError('minlength') || control.hasError('maxlength');
    const hasPatternError = control.hasError('pattern');
    let actualValue;
    let requiredValue;
    if (hasRequiredError) {
      return this.translate.instant('MESSAGE.ENTER-REQUIRED-CODE');
    } else if (hasPatternError) {
      actualValue = control.errors.pattern.actualValue;
      return '\''
        .concat(String(actualValue))
        .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
        .concat(this.translate.instant('TITLE.VERIFICATION-CODE'));
    } else if (hasnotRequiredSizeError) {
      actualValue = control.value;
      if (control.errors.minlength) {
        requiredValue = control.errors.minlength.requiredLength;
        return '\''
          .concat(String(actualValue))
          .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-THE-MINIMUM-REQUIRED-SIZE'))
          .concat(this.translate.instant('MESSAGE.VERIFICATION-CODE-OF'))
          .concat(requiredValue)
          .concat(this.translate.instant('MESSAGE.CHARACTERS'));
      } else if (control.errors.maxlength) {
        requiredValue = control.errors.maxlength.requiredLength;
        return '\''
          .concat(String(actualValue))
          .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-THE-MAXIMUM-REQUIRED-SIZE'))
          .concat(this.translate.instant('MESSAGE.VERIFICATION-CODE-OF'))
          .concat(requiredValue)
          .concat(this.translate.instant('MESSAGE.CHARACTERS'));
      } else {
        return this.translate.instant('MESSAGE.ERROR-GENERAL-OF-VERIFICATION-CODE-SIZE');
      }
    }
  }

  public cleanForm() {
    this.urlStream = {};
    this.operatorsInfo = [];
  }

  public openModalSeeCertificateDetail(index: number) {
    const modalRef = this.modalService.open(CertificateDetailComponent, {size: 'lg'});
    modalRef.componentInstance.operatorInfo = this.operatorsInfo[index];
    modalRef.componentInstance.resumeHashResource = this.resumeHashResource;
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.haveDocumentIntegrity = this.hasDocumentIntegrity(this.operatorsInfo[index]);
  }

  public getClassMaxHeight(operatorInfo: Operator[]): string {
    switch (operatorInfo.length) {
      case 0:
        return 'max-height-0';
      case 1:
        return 'max-height-1';
      case 2:
        return 'max-height-2';
      case 3:
        return 'max-height-3';
      case 4:
        return 'max-height-4';
      default:
        return 'max-height-5';
    }
  }

  public getClassOperatorInfo(operatorInfo: Operator): string {
    if (Constant.CORRECT_OPERATION === operatorInfo.correctOperation) {
      if (Constant.OLD_SIGNATURE === operatorInfo.isOldSignature) {
        return 'fa-exclamation-circle custom-icon-alert';
      } else {
        switch (operatorInfo.operationId) {
          case Constant.SIGN_OPTION:
            if (TypeSignature.DIGITAL === operatorInfo.typeSignature) {
              return 'fa-check-circle custom-icon-success';
            } else if (TypeSignature.ELECTRONIC === operatorInfo.typeSignature) {
              return 'fa-signature';
            } else {
              return 'fa-check-circle';
            }
          case Constant.REVIEW_OPTION:
            return 'fa-check-circle custom-icon-primary';
        }
      }
    } else {
      return 'fa-times-circle custom-icon-warn';
    }
  }

  public showModalSignatureInfo(operatorInfo: Operator): void {
    const title = this.translate.instant('TITLE.SIGNATURE-VALIDITY');
    if (Constant.CORRECT_OPERATION === operatorInfo.correctOperation) {
      if (Constant.OLD_SIGNATURE === operatorInfo.isOldSignature) {
        Dialog.show(InformType.Warning, title, this.translate.instant('MESSAGE.DOCUMENT-ALREADY-HAD-SIGNATURE'));
      } else {
        Dialog.show(InformType.Success, title, this.translate.instant('MESSAGE.SIGNATURE-IS-VALID'));
      }
    } else {
      Dialog.show(InformType.Success, title, this.translate.instant('MESSAGE.SIGNATURE-IS-NOT-VALID'));
    }
  }

  /* Enviamos la solicitud a backend para verificar si ya paso 1 minuto desde la descarga anterior. */
  verifyIntervalTimeDownload(resumeHash: any) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/').concat('verify-code/' + resumeHash + '/permission/download');
    this.publicService.verifyTimeToDownload(url).subscribe((next: any) => {
      this.loading = false;
      if (Boolean(JSON.parse(next.enabledPermissionDownload)) && Boolean(JSON.parse(next.enabledIntervalTimeDownload))) {
        this.downloadDocument(next, resumeHash);
      } else {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENT-VERIFICATION'), next.message);
      }
    }, error => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENT-VERIFICATION'));
    });
  }

  verifyHavePermission() {
    const url = Constant.ROOT_API_V1.concat('/public/').concat('verify-code/' + this.resumeHashResource + '/have/permission');
    this.publicService.verifyHavePermission(url).subscribe((next: any) => {
      this.havePermissionToDownload = Boolean(JSON.parse(next.havePermissionDownload));
    }, error => {
      this.havePermissionToDownload = false;
    });
  }

  private downloadDocument(next: any, resumeHash: string) {
    this.loading = true;
    this.urlStream = Constant.ROOT_API_V1.concat('/public/documents/resources/')
      .concat(resumeHash)
      .concat('/stream');
    this.publicService.download(this.urlStream, next.filename).subscribe(blob => {
      this.loading = false;
    }, error => {
      this.loading = false;
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      Dialog.show(InformType.Danger, title);
    });
  }

  hasDocumentIntegrity(operatorsInfo: any) {
    return operatorsInfo.documentIntegrity;
  }

  get showTableOperatorsInfo(): boolean {
    return !this.wrongVerification && (this.operatorsInfo.length !== 0);
  }

  get isCanceled(): boolean {
    if (this.document === undefined) {
      return false;
    }
    return Constant.FINISHED === this.document.finished && DocumentState.CANCELED === this.document.stateId;
  }

  get isModified(): boolean {
    if (this.document === undefined) {
      return false;
    }
    return Constant.FINISHED === this.document.finished && DocumentState.MODIFIED === this.document.stateId;
  }

  get isReplacerFinished(): boolean {
    const maxIndex = this.documentmodifications.length - 1;
    const replacer: Document = this.documentmodifications[maxIndex].documentByDocumentIdNew;
    return Constant.FINISHED === replacer.finished;
  }
}
